module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=WF - Wallis and Futuna.5423eb92.svg";